var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiSoyFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.352 6.369c-2.618 1.293-.83 2.782-1.699 4.98-.382.967-1.85 1.34-2.188 1.656-1.337 1.25-.924 3.405.826 4.31 1.75.904 4.474.323 6.268-2.012 1.397-1.818 1.467-4.017 1.308-5.52-.179-1.68-2.627-4.347-4.515-3.414z",
    fill: "#31544e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.041 3.706L4.706 20.959",
    stroke: "#31544e",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--soy-free-0edd92b2ffb99b5e42c4f6dc20beb763.svg";
export { SvgIconUiSoyFree as Component };